import { NgModule } from '@angular/core';
import { PIPELINE_SERVICE_INJECTION_TOKEN } from '../pipeline/pipeline-service.interface';
import { PIPELINE_BOARD_SERVICE_CONFIG_TOKEN, SALESPERSON_ID_TOKEN } from './tokens';
import { MARKET_ID_TOKEN, PARTNER_ID_TOKEN } from '../tokens';
import { PipelineBoardService } from './pipeline-board.service';
import { PipelineFiltersServiceModule } from '../../filters/filters-service/pipeline-filters-service.module';
import { PipelineBoardServiceConfig } from './interfaces';
import { Observable } from 'rxjs';
import { OpportunityServiceModule } from '../../sales-opportunities/opportunity-service.module';

@NgModule({
  imports: [PipelineFiltersServiceModule, OpportunityServiceModule],
  providers: [
    PipelineBoardService,
    {
      provide: PIPELINE_SERVICE_INJECTION_TOKEN,
      useExisting: PipelineBoardService,
    },
    { provide: PARTNER_ID_TOKEN, deps: [PIPELINE_BOARD_SERVICE_CONFIG_TOKEN], useFactory: partnerIdFactory },
    { provide: MARKET_ID_TOKEN, deps: [PIPELINE_BOARD_SERVICE_CONFIG_TOKEN], useFactory: marketIdFactory },
    { provide: SALESPERSON_ID_TOKEN, deps: [PIPELINE_BOARD_SERVICE_CONFIG_TOKEN], useFactory: salespersonIdFactory },
  ],
})
export class PipelineBoardServiceModule {}

function partnerIdFactory(config: PipelineBoardServiceConfig): Observable<string> {
  return config.partnerId$;
}

function marketIdFactory(config: PipelineBoardServiceConfig): Observable<string> {
  return config.marketId$;
}

function salespersonIdFactory(config: PipelineBoardServiceConfig): Observable<string> {
  return config.salespersonId$;
}
